import {useEffect, useState} from "react";

export const SCHEDULER_MOBILE_QUERY = "(max-width: 767.98px)";

function getMediaQueryMatch(query) {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return false;
    }

    return window.matchMedia(query).matches;
}

export default function useSchedulerMobileLayout() {
    const [isMobile, setIsMobile] = useState(() => getMediaQueryMatch(SCHEDULER_MOBILE_QUERY));

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
            return undefined;
        }

        const mediaQuery = window.matchMedia(SCHEDULER_MOBILE_QUERY);
        const handleChange = (event) => setIsMobile(event.matches);
        setIsMobile(mediaQuery.matches);

        if (typeof mediaQuery.addEventListener === "function") {
            mediaQuery.addEventListener("change", handleChange);
            return () => mediaQuery.removeEventListener("change", handleChange);
        }

        mediaQuery.addListener(handleChange);
        return () => mediaQuery.removeListener(handleChange);
    }, []);

    return isMobile;
}
